import React from "react";
import { LeadingClinicForm } from "~/components/elements/LeadingClinicForm";
import "~/styles/plano-texas.css";
import "~/styles/doyles-town.css";

export const LeadingClinic = (props) => {    
    const {
        subTitle,
        mainHeading,
        content,
        backgroundImage,
        logoGroup,
        starImages,
        cidValue,
        guaranteeContent,
        leadingFormRedirectionUrl
    } = props;  

    const bgImage = backgroundImage?.localFile?.publicURL || '/hearing-bg.jpg';

    return (
        <>
        <section className="pt-leading-clinic-main-section relative w-full flex items-center justify-center font-sans text-gray-800">
            {/* Background Image with Blur & Dark Overlay */}
            <div className="absolute inset-0 bg-cover" style={{ backgroundImage: `url(${bgImage})` }}></div>
            <div className="absolute inset-0  bg-opacity-30"></div>

            {/* Main Content */}
            <div className="main-content-section relative z-10 w-full max-w-7xl  py-12 md:py-24 flex flex-col md:flex-row  justify-between gap-9">
                
                {/* Left Content */}
                <div className="text-white max-w-xl main-leading-clinic-section">
                    <div className="bg-yellow-300 text-gray-900 block  rounded-full text-sm font-semibold mb-7">
                        <span className="leading-clinic-subtitle-span w-full py-3 bg-blue-600 text-white font-semibold rounded-full hover:bg-blue-700 transition">{subTitle}</span>
                    </div>
                    <h1 className=" md:text-5xl text-white font-extrabold leading-tight mb-6">
                        {mainHeading}
                    </h1>
                    <div className="text-lg font-medium mb-10 mr-2" dangerouslySetInnerHTML={{ __html: content }} />
                    <div className="8">
                        {/* {Array(5).fill(0).map((_, i) => <span key={i}>★</span>)} */}
                        <img key={0} src={starImages.localFile.publicURL} alt={starImages.altText} className="yesHearingLogoImage2 "/>
                    </div>
                    <p className="font-[14px] uppercase text-white/70 mb-5 pt-seen-in">As Seen In</p>
                    <div className="flex flex-wrap items-center justify-start gap-6 pt-leading-clinic-logos">
                        {logoGroup?.images?.map((logo, i) => (
                            <img key={i} src={logo.image.localFile.publicURL} alt={logo.image.altText} className="yesHearingLogoImage "/>
                        ))}
                    </div>
                </div>

                {/* Right Form Box */}
                <LeadingClinicForm cidValue={cidValue} redirectionUrl={leadingFormRedirectionUrl}/>

            </div>
        </section>

        <section className="pt-leading-clinic-main-section-2 relative w-full font-sans text-gray-800">
            {guaranteeContent && (
                <WeGuranteeSection heading={guaranteeContent.title} priceIcon={guaranteeContent.gauranteeLogo.localFile.publicURL} /> 
            )}
        </section>
        </>
    );
};


export const WeGuranteeSection = ({heading, priceIcon}) => {
  return (
    <>
      <div className="flex justify-center items-center ">
        <hr className="w-20 border-[#d4d4d4]" />
        <img
          src="https://cms.yeshearing.com/wp-content/uploads/2025/06/star.svg"
          alt="Best Price Guarantee Stamp"
          className="w-[66px] h-[76px]"
        />
        <hr className="w-20 border-[#d4d4d4]" />
      </div>

      <div className="flex  flex-wrap justify-center items-center pt-heading-top-container">
        <h2 className="text-2xl md:text-3xl font-bold text-[#0c1a3e] pt-heading-top text-center">
          {heading}
        </h2>

        <div className="md:block">
          <img
            src={priceIcon}
            alt="Best Price Guarantee Stamp"
            className="w-[152px] h-[144px]"
          />
        </div>
      </div>
    </>
  ) 
}
